export const parseConfig = {
  URL: process.env.REACT_APP_SERVER_URL,
  JAVASCRIPT_KEY: process.env.REACT_APP_JAVASCRIPT_KEY,
  APP_ID: process.env.REACT_APP_APP_ID,
  MASTER_KEY: process.env.REACT_APP_MASTER_KEY,
};
